import React, {Component} from "react";
import globe from "../../resources/assets/globe.svg"
import { connect } from "react-redux";
import { userLocale } from "../../store/actions/locale";
import { ENGLISH_LOCALE, SPANISH_LOCALE } from "../../languages";

class SwitchLanguage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: typeof this.props.checked === "boolean" ? this.props.checked : (this.props.locale.lang === 'es'),
        };
    }

    componentDidUpdate(_, prevState) {
        const {checked} = this.props;
        if (typeof checked === "boolean" && checked !== prevState.checked) {
            this.setState({ checked });
        }
    }

    toggle = async () => {
        const { checked } = this.state;
        this.setState({ checked: !checked });
        let user_locale = checked ? ENGLISH_LOCALE : SPANISH_LOCALE;
        await this.props.userLocale(user_locale);
    };

    render = () => {
        const cls = this.state.checked ? "on" : "off";

        return (
            <div className="switch btn " onClick={this.toggle}>
                <div className="switch-group">
                    <span className="switch-on btn">ES</span>
                    <span className="switch-off btn">US</span>
                    <img alt='language' src={globe} className={`switch-handle btn ${cls}`} />
                </div>
            </div>
        );
    };
}

const mapStateToProps = state => ({
    locale: state.locale
});

const SwitchLanguageComponent = connect(mapStateToProps, { userLocale })(SwitchLanguage);

export { SwitchLanguageComponent as SwitchLanguage };
